import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-country',
  templateUrl: './admin-country.component.html',
  styleUrls: ['./admin-country.component.css']
})
export class AdminCountryComponent implements OnInit, OnDestroy {
  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  countries: any[] = [];
  cols: any[];
  formdata;
  display = false;
  displayaddcountry = false;
  result = '';
  subscriptions: Subscription[] = [];
  value: any;

  constructor(
    private adminService: AdminService,
    private messageService: MessageService,
    public confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.cols = [
      { field: 'isoCode', header: 'Iso Code' },
      { field: 'name', header: 'Namn' },
      { field: 'order', header: 'Sorteringsordning' }
    ];
    this.getCountries();
  }

  edit(formdata) {
    this.formdata = formdata;
    this.display = true;
  }

  getCountries() {
    this.adminService.GetCountriesAsync().subscribe(data => {
      if (data) {
        this.countries = data;
      }
    });
  }

  saveCountry(evt) {
    this.adminService.UpdateCountry(evt).subscribe(x => {
      this.display = false;
      this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Land uppdaterat.' });
      this.getCountries();
    });
  }

  saveAddCountry(evt) {
    this.adminService.AddCountry(evt).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Land tillagt.' });
        this.getCountries();
        this.displayaddcountry = false;
      }
    });
  }

  remove(rowData) {
    this.confirm(rowData);
  }

  confirm(rowdata) {
    this.confirmDialog(rowdata);
  }

  confirmDialog(rowdata): void {
    this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du radera valt land?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.deleteCountry(rowdata);
      },
      reject: () => {
      }
    });
  }

  deleteCountry(rowdata) {
    this.adminService.RemoveCountry(rowdata).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Land raderat.' });
        this.getCountries();
      }
    });
  }

  cancelEdit() {
    this.display = false;
  }

  cancelAdd() {
    this.displayaddcountry = false;
  }
  addCountry() {
    this.displayaddcountry = true;
  }

  exportToCSV() {
    // tslint:disable-next-line:max-line-length
    const firstrow = 'Id;Iso Code;Namn;Sorteringsordning';
    const filnamn = 'OF_countries';
    CSVDataService.exportToCsv(filnamn + '.csv', this.countries, firstrow);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.value = null;
    this.globalfilter.nativeElement.value = null;
  }
}
